// extracted by mini-css-extract-plugin
export default {"summaryContainer":"YbiHCh","summaryContainerItem":"wgFo9J","downloadableReportContainer":"GphXpA"};